/**
 * guessEmoji — picks a friendly emoji for a product/category by keyword.
 *
 * Real products don't have photos yet (image hosting comes with Cloudinary),
 * so instead of an ugly empty box we show a relevant emoji. Purely cosmetic —
 * it never touches data. Once real images exist, the ProductCard uses those
 * and this becomes the fallback only.
 */

const RULES = [
  [/chees|paneer/i, '🧀'],
  [/butter|ghee/i, '🧈'],
  [/milk|dairy|curd|yog|lassi/i, '🥛'],
  [/bread|bun|pav|bakery|toast/i, '🍞'],
  [/egg/i, '🥚'],
  [/rice|atta|flour|wheat|grain/i, '🌾'],
  [/sugar|salt/i, '🧂'],
  [/oil/i, '🛢️'],
  [/dal|pulse|lentil|bean/i, '🫘'],
  [/coffee/i, '☕'],
  [/tea/i, '🍵'],
  [/juice|drink|cola|soda|water|beverage|sting|coke|pepsi/i, '🥤'],
  [/choco|candy|sweet|dessert/i, '🍫'],
  [/biscuit|cookie|rusk/i, '🍪'],
  [/noodle|pasta|maggi|instant/i, '🍜'],
  [/chip|snack|namkeen|kurkure|lays/i, '🍿'],
  [/cashew|almond|nut|dry\s?fruit/i, '🥜'],
  [/fruit|apple|banana|mango/i, '🍎'],
  [/vegetable|veggie|onion|potato|tomato/i, '🥬'],
  [/soap|detergent|clean|wash/i, '🧼'],
  [/shampoo|hair/i, '🧴'],
  [/brush|paste|dental|oral/i, '🪥'],
  [/pen|pencil|note|book|stationery|paper/i, '📒'],
  [/coconut/i, '🥥'],
];

export function guessEmoji(text = '') {
  for (const [pattern, emoji] of RULES) {
    if (pattern.test(text)) return emoji;
  }
  return '📦';
}

export default guessEmoji;
